'use client';

import React, { useCallback } from 'react';
import { Checkbox, MenuItem, TextField } from '@mui/material';
import { Region } from '@peerless/data-access/strapi';
import { usePathname, useRouter, useSearchParams } from '@/navigation';

interface Props {
  regions: Region[];
  selected: string[];
}

export const RegionSelectFilter: React.FC<Props> = ({ regions, selected }) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const onChange = useCallback(
    (regions: string) => {
      const params = new URLSearchParams(searchParams.toString());
      params.set('regions', regions);
      router.push(`${pathname}?${params.toString()}`);
    },
    [searchParams, pathname, router]
  );

  return (
    <TextField
      label="Regions"
      value={selected}
      onChange={x => {
        if (!x.target.value) return;

        onChange(x.target.value as string);
      }}
      select
      SelectProps={{ multiple: true }}
      InputLabelProps={{ shrink: true }}
      fullWidth
    >
      {regions.map(region => (
        <MenuItem key={region.documentId} value={region.documentId}>
          <Checkbox checked={selected.includes(region.documentId.toString())} />
          {region.name}
        </MenuItem>
      ))}
    </TextField>
  );
};
